/** @jsxImportSource @emotion/react */

import React, { useState } from "react";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import SizeToolbar from "components/tools/Size";
import EditorSettings from "components/admin/EditorSettings";
import RadiusManager from "components/RadiusManager";

import RoundSize from "app/size/RoundSize";
import { useStoreon } from "storeon/react";

import t from "translations";
import { useCanvasSettings } from "utils/canvas";
import { useProboSize } from "utils/probo";

const SizeManger = ({ isAdmin, editorType }) => {
  const [tab, setTab] = useState(0);
  const { canvas, product } = useStoreon("canvas", "product");
  const { isDynamicRadius, isDynamicSize } = useCanvasSettings();
  const {lockedWidth, lockedHeight} = useProboSize();

  if (isAdmin) {
    return (
      <React.Fragment>
        <SizeToolbar />
        <RadiusManager />
        {editorType === "printfile" && <EditorSettings />}
      </React.Fragment>
    );
  }

  const handleTabChange = (e, val) => {
    if (val === 0 && canvas) {
      canvas.DPE.cutZone.setCutRadius(0);
    }
    setTab(val);
  };

  if (product?.proboProduct) {
    if (lockedWidth && lockedHeight) {
      return null;
    } else {
      return <SizeToolbar />;
    }
  }

  if (!isDynamicRadius && isDynamicSize) {
    return <SizeToolbar />;
  }

  if (isDynamicRadius && !isDynamicSize) {
    return <RadiusManager />;
  }

  return (
    <React.Fragment>
      <Tabs value={tab} onChange={handleTabChange}>
        <Tab label={t.customSize} />
        {/* <Tab label={t.roundSize} /> */}
      </Tabs>
      {tab === 0 && (
        <React.Fragment>
          <SizeToolbar />
          <RadiusManager />
        </React.Fragment>
      )}
      {tab === 1 && <RoundSize />}
    </React.Fragment>
  );
};

export default SizeManger;
